var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _rect3, _rect4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 90C180 139.706 139.706 180 90 180C40.2944 180 0 139.706 0 90C0 40.2944 40.2944 0 90 0C139.706 0 180 40.2944 180 90Z",
    fill: "url(#paint0_linear_5403_27577)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.173 47H47.4346V68.4346H26V89.8691H47.4346V132.738H154.607V89.8691H133.173V47Z",
    fill: "#CA9660"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68.8691,
    y: 89.8691,
    width: 21.4344,
    height: 21.4344,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 111.738,
    y: 89.8691,
    width: 21.4344,
    height: 21.4344,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.173 47H47.4346V132.738H68.8691V68.4346H133.173V47Z",
    fill: "#793D20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.173 47H47.4346V68.4346H26V89.8691H47.4346V132.738H154.607V89.8691H133.173V47Z",
    fill: "#CA9660"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.173 47H47.4346V132.738H68.8691V68.4346H133.173V47Z",
    fill: "#793D20"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68.8691,
    y: 89.8691,
    width: 21.4344,
    height: 21.4344,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 111.738,
    y: 89.8691,
    width: 21.4344,
    height: 21.4344,
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5403_27577",
    x1: 90,
    y1: 0,
    x2: 90,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEC9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGok);
export default __webpack_public_path__ + "static/media/gok.a6e6dabb3e6ad9812c292978a43255fb.svg";
export { ForwardRef as ReactComponent };